export default __webpack_public_path__ + "static/media/f1.622d3a8b.png";